import View from "./View";

class ForgotPwdView extends View {
  _emailField = document.querySelector("#email");
  _formForgotPwd = document.querySelector(".form-forgot-password");
  _submitBtn = document.querySelector("#submit-email");

  // Initialize event listeners to control the submit button state
  initSubmitBtn() {
    this._emailField.addEventListener(
      "input",
      this.toggleSubmitButton.bind(this),
    );
  }

  renderValidation() {
    this._submitBtn.onclick = () => {
      const isValid = this.testEmail(this._emailField.value);

      if (isValid) {
        //this._formForgotPwd.reset();
      }
    };
  }

  // Toggle the state of the submit button based on input fields
  toggleSubmitButton() {
    const MAX_EMAIL_LENGTH = 256;

    if (
      !this.testEmail(this._emailField.value) ||
      this._emailField.value.length > MAX_EMAIL_LENGTH
    ) {
      // Disable submit button
      this._submitBtn.disabled = true;
    } else {
      // Enable submit button
      this._submitBtn.disabled = false;
    }
  }
}

export default new ForgotPwdView();
